// extracted by mini-css-extract-plugin
export default {"logo":"MembersLogo_logo__JQXSh"};